module.exports = __webpack_public_path__ + "static/media/digger.6afdb6b9.png";